<template>
  <canvas :height="height" :width="width" id="financements-percus-deal-graph"></canvas>
</template>
<script>
import {SOLUTIA} from "@/constants/Colors";
import {Chart} from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {arrondirKeuros, arrondirKeurosAsNumber} from "@/util";

export default {
  name: "FinancementsPercusDEALGraph",
  props: {
    data: Array,
    height: {
      type: Number,
      default: 600,
    },
    width: {
      type: Number,
      default: 600,
    }
  },
  mounted: async function () {
    let statusFetchStatus = this.$store.getters["dossier/statuts/statut_fetch_status"];
    if (statusFetchStatus === "INITIAL" || statusFetchStatus === "ERROR") {
      await this.$store.dispatch("dossier/statuts/getStatuts");
    }
    // eslint-disable-next-line no-unused-vars
    const chartData = {
      label: "Financements perçus DEAL",
      labels: this.data.map(data_of_year => data_of_year.year),
      datasets: [
          {
          label: "Total Perçu",
          data: this.data.map(data_of_year => arrondirKeurosAsNumber(data_of_year.total_paye_deal)),
          datalabels: {
            color: '#ffffff',
            font: {
              size: 16
            }
          },
          backgroundColor: SOLUTIA[0]
        },
        {
          label: "Reste à payer demandé",
          data: this.data.map(data_of_year => arrondirKeurosAsNumber(data_of_year.reste_a_payer_deal_demande)),
          datalabels: {
            color: '#ffffff',
            font: {
              size: 16
            }
          },
          backgroundColor: SOLUTIA[1]
        },
        {
          label: "Reste à payer non demandé",
          data: this.data.map(data_of_year => arrondirKeurosAsNumber(data_of_year.reste_a_payer_deal_non_demande)),
          datalabels: {
            color: '#ffffff',
            font: {
              size: 16
            }
          },
          backgroundColor: "#800020"
        },
          {
          label: "TOTAL",
          tooltip: {
            enabled: false
          },
          data: this.data.map((data_of_year) => arrondirKeurosAsNumber(data_of_year.total_financements_deal / 20)),
          datalabels: {
            color: 'black',
            clamp: true,
            anchor: "end",
            formatter: function (value, context) {
              return arrondirKeuros(that.data[context.dataIndex].total_financements_deal);
            },
            font: {
              size: 16,
              weight: "bold"
            }
          },
          backgroundColor: "#ffffff00"
        },
      ],
    }
    // eslint-disable-next-line no-unused-vars
    const config = {
      title: {
        display: true,
        text: "Suivi des financements DEAL",
        fontSize: 16,
      },
      legend: {
        display: false,
      },
      scales: {
        yAxes: [{
          stacked: true,
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            drawBorder: false,
          }
        }],
        xAxes: [{
          stacked: true,
          gridLines: {
            display: false,
          }
        }]
      },

    }
    let that = this;
    this.$nextTick(function () {
      const ctx = document.getElementById('financements-percus-deal-graph');
      that.chart = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: "bar",
        //...defaultData
        data: chartData,
        options: config,
      });
    })
  },
  data: function () {
    return {
      chart: null
    }
  },
  computed: {
    statuts() {
      return this.$store.getters["dossier/statuts/statuts"];
    },
  },
  methods: {}
}
</script>

<style scoped>

</style>